require('./command.js');

(function(){
  PegasusTemplate.DeleteColumnCommand = PegasusTemplate.Command.extend({
    klass: null,
    backup: null,
    sourceElement: null,
    callback: null,
    parent: null,
    childPosition: null,
    descriptionClass: 'deleted',
    description: function(){
      return Em.I18n.t('command_descriptions.deleted_column');
    }.property(),
    execute: function() {
      var parent = PegasusTemplate.blockRegionInstance,
        row = parent.objectAt( this.get('rowPosition') ),
        sourceId = this.get('desiredPosition'),
        sourceCode = this.get('backup'),
        _super = this._super.bind(this);

      PegasusTemplate.lookupController('historyOperations').setProperties({
        'controllers.blockOperations.content': null,
        'controllers.rowOperations.content': null
      });

      var element = $(sourceCode);
      var columnA = element.find('#' + sourceId);
      var parentA = columnA.parent();
      columnA.remove();

      var source = element[0].outerHTML;

      parent.removeObject( row );

      parent.insertAt( this.get('rowPosition'), this.get('rowKlass').create({
        container: parent.container,
        sourceElement: source
      }) );

      _super();
    },

    unexecute: function(callback){
      var parent = PegasusTemplate.blockRegionInstance,
        reborn = this.get('rowKlass').create({
          container: parent.container,
          sourceElement: this.get('backup')
        }),
        _super = this._super.bind(this);

      parent.removeObject( parent.objectAt( this.get('rowPosition') ) );
      parent.insertAt( this.get('rowPosition'), reborn );

      Em.run.scheduleOnce( 'afterRender', reborn, function(){
        this.set('isVisible', true);
        this.$().addClass('bounce-in-right').addClass('animated').addClass('make_transit');
        _super();
      });
    }
  });
})();
